import * as Sentry from "@sentry/react";

const SENTRY_DSN = "https://28683a487b25539c84072c4c3ad3f61f@o4511594347364352.ingest.us.sentry.io/4511787826348037";

export function initSentry() {
  const dsn = SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.2,

    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    // Don't send errors from localhost
    beforeSend(event) {
      if (window.location.hostname === "localhost") return null;
      return event;
    },
  });
}

export function identifySentryUser(user: {
  id: string;
  email?: string | null;
}) {
  Sentry.setUser({ id: user.id, email: user.email ?? undefined });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export function captureSentryException(
  err: unknown,
  context?: Record<string, unknown>,
) {
  Sentry.withScope((scope) => {
    if (context) scope.setExtras(context);
    Sentry.captureException(err);
  });
}
